import{a as o}from"./chunk-ODGQYPUL.js";import{m as r}from"./chunk-HBP5N4FR.js";r();import i from"react";function p(){return o(),i.createElement(i.Fragment,null)}export{p as a};
//# sourceMappingURL=chunk-CMF7545O.js.map
